import tippy, { hideAll } from "tippy.js";
import { ready } from "../utils/listeners";

window.initializeTooltips = () => {
  tippy("[data-tippy-content]", {
    theme: "dark",
    arrow: false,
    animation: "shift-away"
  });
  tippy(".out-of-stock", {
    content: "Currently out of stock",
    arrow: true,
    theme: "dark"
  });
  hideAll();
};

ready(() => {
  window.initializeTooltips();
});
